import React, { Component } from 'react';
import LinkedInIcon from '../assets/logos/linkedin.png';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <h1><strong>Pionova AB</strong></h1>
        <h6>
          <strong>
            <a href="mailto: patrik@pionova.se">patrik@pionova.se</a>
          </strong>
        </h6>
        
        <a href="https://se.linkedin.com/company/pionova">
          <img className="mt-2 img-fluid small-icon"
            src={LinkedInIcon}
            alt="logo" />
        </a>

      </div>
    );
  }
}
